module.exports = __webpack_public_path__ + "static/media/airship-blimp-dirigible-svgrepo-com.15c8f159.svg";